import React, { useState } from 'react';
import useSymbolTrie from '../hooks/useSymbolTrie';

function getSuggestions(trie, prefix, limit = 10) {
    const results = [];

    function dfs(node, path) {
        if (results.length >= limit) return;
        if (node._) results.push({ symbol: path, meta: node._ });

        for (const key of Object.keys(node)) {
            if (key !== '_') dfs(node[key], path + key);
        }
    }

    let node = trie;
    for (const char of prefix.toUpperCase()) {
        if (!node?.[char]) return [];
        node = node[char];
    }

    dfs(node, prefix.toUpperCase());
    return results;
}

const SymbolSearchInput = ({ onAdd }) => {
    const [input, setInput] = useState('');
    const [error, setError] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const { trie } = useSymbolTrie();

    const handleChange = (e) => {
        const val = e.target.value.toUpperCase();
        setInput(val);
        if (trie && val.length >= 1) {
            setSuggestions(getSuggestions(trie, val));
        } else {
            setSuggestions([]);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const symbols = getSuggestions(trie, input);
        const selected = symbols.find(s => s.symbol === input);
        if (!trie || !selected) {
            setError('Unknown ticker');
            return;
        }
        
        setError('');
        onAdd(selected.symbol); // or pass the full `selected` object if needed
        setInput('');
        setSuggestions([]);
    };

    return (
        <div style={{ maxWidth: 300, position: 'relative' }}>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    placeholder="Add Stock"
                    value={input}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '8px' }}
                />
                <button type="submit">Add</button>
            </form>

            {error && <div style={{ color: 'red', fontSize: '0.85em' }}>{error}</div>}

            {suggestions.length > 0 && (
                <ul style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    zIndex: 1000,
                    background: '#1e1e1e',
                    padding: '4px',
                    marginTop: '4px',
                    borderRadius: '4px',
                    maxHeight: '180px',
                    overflowY: 'auto',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.4)'
                }}>
                    {suggestions.map(s => (
                        <li
                            key={s.symbol}
                            onClick={() => {
                                setInput(s.symbol);
                                setSuggestions([]);
                            }}                            
                            style={{
                                cursor: 'pointer',
                                padding: '6px 8px',
                                borderBottom: '1px solid #333',
                                fontSize: '0.9em'
                            }}
                        >
                            <strong>{s.symbol}</strong> – <span style={{ color: '#aaa' }}>{s.meta.n}</span> <span style={{ color: '#666' }}>({s.meta.e})</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>

    );
};

export default SymbolSearchInput;
